module.exports = __webpack_public_path__ + "img/bottom_mid.b9efe2cf.png";